class GetNewListHighlighted {
  static make(fullList, data, highlight) {
    let newList = [...fullList];

    // Si data es un array, procesamos cada elemento
    const dataArray = Array.isArray(data) ? data : [data];

    dataArray.forEach((dataItem) => {
      const existingIndex = newList.findIndex((item) => item.id === dataItem.id);

      if (existingIndex !== -1) {
        // Actualizar elemento existente
        newList[existingIndex] = {
          ...newList[existingIndex],
          ...dataItem,
          highlight,
        };
      } else {
        // Agregar nuevo elemento al principio
        newList.unshift({
          ...dataItem,
          highlight,
        });
      }
    });

    return newList;
  }
}

export default GetNewListHighlighted;
